module.exports = __webpack_public_path__ + "static/media/yoru.3c9f1b76.png";